export enum AutomationFilterType {
  STATUS = 'Automation Status',
}
